import { FailedToLoadNotifications } from './components/FailedToLoadNotifications'
import { OrderStepNotifications } from './components/OrderStepNotifications'
import { OrderStepTrackingLink } from './components/OrderStepTrackingLink'
import { OrderStepUnsubscribeInfo } from './components/OrderStepUnsubscribeInfo'
import { useOrderStepNotificationStatus } from './hooks/useOrderStepNotificationStatus'
import { useOrderStepNotificationUnsubscription } from './hooks/useOrderStepNotificationUnsubscription'
import { useOrderStepTrackingLinkStatus } from './hooks/useOrderStepTrackingLinkStatus'

type Props = {
  extendedOrder: uui.domain.client.rm.ExtendedOrderStep
  orderDate?: string
}

export function OrderStepNotification(props: Props) {
  const { extendedOrder, orderDate } = props

  const trackingLinkStatus = useOrderStepTrackingLinkStatus(extendedOrder, orderDate)
  const notificationStatus = useOrderStepNotificationStatus(extendedOrder, orderDate)
  const unsubscriptionStatus = useOrderStepNotificationUnsubscription(extendedOrder, orderDate)

  if (
    trackingLinkStatus === 'failed' &&
    notificationStatus === 'failed' &&
    unsubscriptionStatus === 'failed'
  ) {
    return <FailedToLoadNotifications />
  }

  return (
    <>
      <OrderStepTrackingLink status={trackingLinkStatus} extendedOrderId={extendedOrder.id} />
      <OrderStepUnsubscribeInfo status={unsubscriptionStatus} extendedOrder={extendedOrder} />
      <OrderStepNotifications status={notificationStatus} extendedOrderId={extendedOrder.id} />
    </>
  )
}
